type StreamCancelledWaiter = {
  resolve: () => void;
  timer: ReturnType<typeof setTimeout>;
};

const waitersByConversationId = new Map<string, StreamCancelledWaiter[]>();

/** Resolves when STREAM_CANCELLED is handled for this conversation, or after timeout. */
export function waitForStreamCancelled(
  conversationId: string,
  timeoutMs = 15000
): Promise<void> {
  return new Promise((resolve) => {
    const entry: StreamCancelledWaiter = {
      resolve: () => {
        clearTimeout(entry.timer);
        resolve();
      },
      timer: setTimeout(() => {
        removeWaiter(conversationId, entry);
        resolve();
      }, timeoutMs),
    };

    const waiters = waitersByConversationId.get(conversationId) ?? [];
    waiters.push(entry);
    waitersByConversationId.set(conversationId, waiters);
  });
}

export function notifyStreamCancelled(conversationId: string): void {
  const waiters = waitersByConversationId.get(conversationId);
  if (!waiters?.length) return;

  waitersByConversationId.delete(conversationId);
  waiters.forEach((waiter) => {
    clearTimeout(waiter.timer);
    waiter.resolve();
  });
}

function removeWaiter(conversationId: string, entry: StreamCancelledWaiter): void {
  const waiters = waitersByConversationId.get(conversationId);
  if (!waiters) return;

  const next = waiters.filter((waiter) => waiter !== entry);
  if (next.length === 0) {
    waitersByConversationId.delete(conversationId);
  } else {
    waitersByConversationId.set(conversationId, next);
  }
}

export function resetStreamCancelledWaiters(): void {
  waitersByConversationId.forEach((waiters) => {
    waiters.forEach((waiter) => clearTimeout(waiter.timer));
  });
  waitersByConversationId.clear();
}
